<template>
  <div class="batch-details">
    <modal
      ref="printingModal"
      template="loading"
      title="Aguarde"
      ref-name="printingModal"
    >
      <p>Imprimindo etiquetas...</p>
    </modal>

    <modal
      ref="loadingReceiptModal"
      template="loading"
      title="Aguarde"
      ref-name="loadingReceiptModal"
    >
      <p>Gerando recibo...</p>
    </modal>

    <print-tag-subheader
      title="Detalhes do Lote"
      :simple-template="true"
      :filter-button-at-new-row="true"
      :search-button-enabled="false"
    >
      <div
        slot="regular-buttons"
        class="container-actions status flex justify-between align-center"
      >
        <div>
          <button
            id="btnPrintBatchLabel"
            class="btn btn-primary btn-regular-size"
            @click="validatePrintingSystemForBatch(batchDetails)"
          >
            <svg-loader
              class="icon-print"
              src="/static/images/icon-print-alternative-white.svg"
            />
            {{ printBtnText }}
          </button>
          <button
            id="btnPrintSamplesLabel"
            class="btn btn-primary btn-regular-size"
            @click="validatePrintingSystemForAllSamples(batchDetails)"
          >
            <svg-loader
              class="icon-print"
              src="/static/images/icon-print-alternative-white.svg"
            />
            IMPRIMIR TODAS
            <span v-if="samples.length > 0">({{ samples.length }})</span>
          </button>
        </div>
        <div class="flex align-center gap-3">
          <PrinterConnectionStatus
            class="mr-n3"
            label-text="Status:"
            @download-plugin-requested="handleDownloadPluginRequested"
          />
          <PrinterConfigButton
            v-if="toggle.printerPlugin && webSocketStatus.connectionState === 'connected'"
            class="mr-4"
            tooltip-direction="left"
            tooltip-text="Configurações da Impressora"
          />
          <printer-calibration />

          <PrinterHelpButton />
        </div>
      </div>
      <document-filter
        v-if="$route.query.tab !== 'aolWs'"
        slot="search-container"
        :loading="isSamplesLoading"
        :total-exams-pending="totalSampleExamsWithDocPending"
      />

      <div slot="alert">
        <Alert
          :alert-text="alertSamples"
          item-name-in-storage="alertSamplesClosed"
          icon="icon-info.svg"
          feature-toggle="webPrinting"
        />
      </div>
    </print-tag-subheader>
    <div class="width-responsiveness">
      <div class="print-tag-batches">
        <div class="print-tag-batches__card-container">
          <div class="collapsed">
            <div class="card-container">
              <spinner v-if="isBatchModalLoading" />
              <batch-card
                v-else
                :batch="batchDetails"
                :is-details-mode="true"
              />
            </div>

            <div class="md-list">
              <empty-cart
                v-if="samples.length === 0 && !isSamplesLoading"
                description="Nenhuma amostra encontrada de acordo com o filtro atual."
                img="/static/images/icon-empty-cart.svg"
              />
              <div
                v-else
                class="print-tag-batch-details-list_container"
              >
                <table class="apoio-datatable relative-head">
                  <colgroup>
                    <col />
                    <col class="column-lis-number" />
                    <col class="column-patient" />
                    <col class="column-material" />
                    <col class="column-os-alvaro" />
                    <col class="column-document" />
                    <col class="column-expander" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th class="print-actions-container center">
                        <span>IMPRIMIR</span>
                      </th>
                      <th @click.prevent="sortColumn('os_lis')">
                        <span
                          title="OS LIS"
                          class="sort-column"
                        >
                          <template v-if="!toggle.covax">OS LIS</template>
                          <template v-else>Requisition Number</template>
                        </span>
                        <md-icon
                          v-if="!toggle.covax"
                          class="md-icon icon-status-info"
                          @click.stop.prevent
                        >
                          info_outline
                          <md-tooltip
                            md-delay="400"
                            md-direction="top"
                          >
                            Número da Ordem de Serviço do sistema do cliente
                          </md-tooltip>
                        </md-icon>
                        <sort-column
                          id="os_lis"
                          @click.prevent="sortColumn('os_lis')"
                        />
                      </th>
                      <th
                        title="PACIENTE (ID LIS)"
                        class="sort-column"
                        @click.prevent="sortColumn('patient_name')"
                      >
                        PACIENTE (ID LIS)
                        <sort-column id="patient_name" />
                      </th>
                      <th @click.prevent="sortColumn('material_description')">
                        <span
                          title="MATERIAL (ACOND)"
                          class="sort-column"
                        >
                          MATERIAL (ACOND)
                        </span>
                        <sort-column
                          id="material_description"
                          @click.prevent="sortColumn('os_lis')"
                        />
                      </th>
                      <th
                        title="OS ÁLVARO"
                        class="sort-column"
                        @click.prevent="sortColumn('number_alvaro_order')"
                      >
                        OS ÁLVARO
                        <sort-column id="number_alvaro_order" />
                      </th>
                      <th class="column-document" />
                      <th />
                    </tr>
                  </thead>
                </table>

                <table class="apoio-datatable">
                  <colgroup>
                    <col />
                    <col class="column-lis-number center" />
                    <col class="column-patient center" />
                    <col class="column-material center" />
                    <col class="column-os-alvaro center" />
                    <col class="column-document" />
                    <col class="column-expander center" />
                  </colgroup>
                  <template v-if="!isSamplesLoading">
                    <tbody
                      v-for="(sample, index) in samples"
                      :key="index"
                      :md-item="sample"
                    >
                      <tr
                        :class="{ expanded: sample.expanded }"
                        class="apoio-datatable__line"
                      >
                        <td
                          align="center"
                          class="print-actions-container"
                        >
                          <md-button
                            class="btn btn-primary"
                            :class="{ 'md-button-printed': sample.printed_status }"
                            @click="validatePrintingSystemForSingleSample(sample)"
                          >
                            <md-tooltip md-direction="top">
                              <span v-if="sample.printed_status">Reimprimir</span>
                              <span v-else>Imprimir</span>
                            </md-tooltip>
                            <svg-loader src="/static/images/icon-individual-print.svg" />
                          </md-button>
                        </td>
                        <td @click.prevent="openSampleDetails(index, sample)">
                          <span
                            :title="sample.os_lis"
                            class="os-lis-span"
                          >
                            {{ sample.os_lis }}
                          </span>
                        </td>
                        <td @click.prevent="openSampleDetails(index, sample)">
                          <span
                            :title="concatNameCode(sample.patient_name, sample.patient_id_lis)"
                            class="patient-name-span"
                          >
                            {{ concatNameCode(sample.patient_name, sample.patient_id_lis) }}
                          </span>
                        </td>
                        <td @click.prevent="openSampleDetails(index, sample)">
                          <span :title="concatNameCode(sample.material_description, sample.material_packaging)">
                            {{ concatNameCode(sample.material_description, sample.material_packaging) }}
                          </span>
                        </td>
                        <td @click.prevent="openSampleDetails(index, sample)">
                          <span :title="sample.number_alvaro_order">{{ sample.number_alvaro_order }}</span>
                        </td>
                        <td
                          class="column-document"
                          @click.prevent="openSampleDetails(index, sample)"
                        >
                          <div
                            class="icon-doc status-icon"
                            :class="'printed-' + sample.printed_status"
                          >
                            <md-tooltip
                              md-delay="400"
                              md-direction="top"
                            >
                              {{ $strings.sampleStatus[sample.printed_status] }}
                            </md-tooltip>
                          </div>
                          <document-icon
                            v-if="sample.docRequired"
                            :is-document-delivered="sample.docDelivered"
                          />
                        </td>
                        <td @click.prevent="openSampleDetails(index, sample)">
                          <div
                            class="status-icon icon-arrow-dropdown"
                            :class="{ 'icon-arrow-dropdown--active': sample.expanded }"
                          >
                            <md-tooltip
                              md-delay="400"
                              md-direction="top"
                            >
                              Detalhes
                            </md-tooltip>
                          </div>
                        </td>
                      </tr>
                      <tr
                        v-if="sample.expanded"
                        class="row-details"
                      >
                        <td
                          colspan="7"
                          class="row-details__container"
                        >
                          <sample-details
                            :sample="sample"
                            @refresh-samples="getSamplesFromBatch()"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <tfoot v-else>
                    <tr>
                      <td colspan="7">
                        <infinite-loading ref="infiniteLoading">
                          <span slot="no-more" />
                          <span slot="no-results" />
                          <span slot="spinner">
                            <spinner />
                          </span>
                        </infinite-loading>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PrinterPluginDownloadModal
      ref="printerPluginDownloadModal"
      ref-name="printerPluginDownloadModal"
    />

    <PrinterModal ref="printerModal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InfiniteLoading from 'vue-infinite-loading';
import { concatNameAndCode } from '@/utils/string-utils';
import { setSortation } from '@/utils/sort-columns';
import notify from '@/api/notification';
import batchService from '@/api/batch';
import sampleService from '@/api/sample';
import label from '@/api/label';
import { BATCH_STATE_PRINTED } from '@/enums';
import mixin from './BatchesMixin';
import printerValidationMixin from '../printerValidationMixin';
import pdfkit from '../../../libs/pdfkit';
import blobstream from '../../../libs/blob-stream';
import strings from '@/strings';

import PrintTagSubheader from '@/components/PrintTag/PrintTagSubheader';
import PrinterCalibration from '@/components/common/calibration/PrinterCalibration';
import BatchCard from '@/components/PrintTag/Batches/Cards/BatchCard';
import SampleDetails from '@/components/PrintTag/Samples/SampleDetails';
import Spinner from '@/components/common/Spinner';
import SortColumn from '@/components/common/SortColumn';
import loadingInfiniteMessage from '@/components/common/LoadingInfiniteMessage';
import DocumentIcon from '@/components/Documents/Laboratory/Flag';
import DocumentFilter from '@/components/Documents/Laboratory/Filter';
import EmptyCart from '@/components/common/EmptyCart';
import Alert from '@/components/common/Alert';
import PrinterConfigButton from '@/components/common/printer/PrinterConfigButton.vue';
import PrinterConnectionStatus from '@/components/common/printer/PrinterConnectionStatus.vue';
import PrinterPluginDownloadModal from '@/components/common/printer/PrinterPluginDownloadModal.vue';
import PrinterModal from '@/components/common/printer/PrinterModal.vue';
import PrinterHelpButton from '@/components/common/printer/PrinterHelpButton.vue';

export default {
  name: 'BatchDetails',
  components: {
    'infinite-loading': InfiniteLoading,
    spinner: Spinner,
    'sample-details': SampleDetails,
    'sort-column': SortColumn,
    'loading-infinite-message': loadingInfiniteMessage,
    'printer-calibration': PrinterCalibration,
    'print-tag-subheader': PrintTagSubheader,
    'batch-card': BatchCard,
    'document-icon': DocumentIcon,
    'document-filter': DocumentFilter,
    'empty-cart': EmptyCart,
    Alert,
    PrinterConfigButton,
    PrinterConnectionStatus,
    PrinterPluginDownloadModal,
    PrinterModal,
    PrinterHelpButton,
  },
  mixins: [mixin, printerValidationMixin],
  props: {
    printTagIndex: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    BATCH_STATE_PRINTED: BATCH_STATE_PRINTED,
    samples: [],
    isBatchModalLoading: true,
    isSamplesLoading: true,
    columnSortStatusSamples: {
      os_lis: 'asc',
      patient_name: 'asc',
      material_description: 'asc',
      number_alvaro_order: 'asc',
    },
    totalSampleExamsWithDocPending: 0,
    alertSamples: strings.alerts.alertSamples,
  }),
  computed: {
    ...mapGetters(['samplePrintingStatus', 'profile', 'toggle', 'batchSamplesSorted', 'batchesSamplesPrintingStatus', 'webSocketStatus', 'defaultPrinter']),
    printBtnText() {
      if (this.batcheSetTab === 'aolWs') {
        if (this.batchDetails.state === 'CLOSED') return 'IMPRIMIR LOTE';
        return 'FECHAR E IMPRIMIR LOTE';
      }
      return 'IMPRIMIR ETIQUETA DE LOTE';
    },
  },
  watch: {
    batchesSamplesPrintingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_INITIAL':
          this.getSamplesFromBatch();
          break;
        default:
          break;
      }
    },
    samplePrintingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_PRINTING':
          this.$refs.printingModal.open();
          this.$analytics.pushAnalyticsEvent('vpageview', {
            page: 'batches/printing-modal',
            'id-usuario': this.profile.id,
            'id-lab': this.profile.id_laboratory,
            nlab: this.profile.laboratoryName,
          });
          break;
        case 'STATUS_INITIAL':
          this.$refs.printingModal.close();
          break;
        case 'STATUS_MISSING_CLIENT':
          this.$refs.printingModal.close();
          notify({
            title: 'AVISO:',
            message: 'Erro ao conectar à impressora. Por favor, verifique se o cliente de impressão está instalado ou faça login novamente.',
          });
          break;
        default:
          break;
      }
    },
    batch: {
      handler(newVal) {
        this.sortColumn(newVal.printSortSelected.value);
      },
      deep: true,
    },
    $route(to, from) {
      this.loadBatchDetailsData();
    },
  },
  async mounted() {
    // Verificar a impressora padrão carregada do localStorage
    await this.initializePrinterFromStorage();

    this.loadBatchDetailsData();
  },
  methods: {
    ...mapActions([
      'batcheSetTab',
      'setWaitingSampleLoadingStatus',
      'showDetailsSample',
      'sortSampleList',
      'showSampleRow',
      'printSamples',
      'sortPrintBatchSetColumn',
      'printAndTransmit',
      'updateBatchDetailsOpened',
      'batchSetSortToSamples',
      'webSocketPrintAndTransmit',
      'webSocketPrintSamples',
    ]),
    printAllSamplesFromBatch() {
      const source = this.batchDetails.source;
      let samplesId = this.samples;
      if (source !== 'AOL2') {
        samplesId = samplesId.map(elem => {
          return elem.barcode;
        });
        samplesId = { barcodeList: samplesId };
      } else {
        samplesId = samplesId.map(elem => {
          return {
            sample_id: elem.sample_id,
            batch: {
              id: elem.batch_id || null,
            },
          };
        });
      }

      this.printSamples({ samplesId, printBatch: false, source })
        .then(() => {
          this.loadBatchDetailsData();
        })
        .catch(() => {
          this.loadBatchDetailsData();
        });

      this.pushEventToAnalytics('Impressão de todas etiquetas de amostras ' + this.batchDetails.source);
    },
    async webSocketPrintAllSamplesFromBatch() {
      await this.executeWithPrinterValidation(() => {
        const batch = this.batchDetails;
        let samplesId = this.samples;
        samplesId = samplesId.map(elem => {
          return elem.barcode || elem.bar_code;
        });
        samplesId = { barcodeList: samplesId };

        this.webSocketPrintSamples({ samplesId, printBatch: false, batch })
          .then(() => {
            this.loadBatchDetailsData();
          })
          .catch(() => {
            this.loadBatchDetailsData();
          });

        this.pushEventToAnalytics('Impressão de todas etiquetas de amostras ' + this.batchDetails.source);
      });
    },
    printSampleFromBatch(sample) {
      const source = this.batchDetails.source;
      let samplesId = sample;
      if (source !== 'AOL2') {
        samplesId = samplesId.map(elem => {
          return elem.barcode;
        });
        samplesId = { barcodeList: samplesId };
      } else {
        samplesId = samplesId.map(elem => {
          return {
            sample_id: elem.sample_id,
            batch: {
              id: elem.batch_id || null,
            },
          };
        });
      }
      this.printSamples({
        samplesId,
        printBatch: false,
        source,
      })
        .then(() => {
          this.loadBatchDetailsData();
        })
        .catch(() => {
          this.loadBatchDetailsData();
        });
      this.pushEventToAnalytics('Impressão de uma etiqueta de amostra' + this.batchDetails.source);
    },
    async webSocketPrintSampleFromBatch(sample) {
      await this.executeWithPrinterValidation(() => {
        const batch = this.batchDetails;
        let samplesId = sample;
        samplesId = samplesId.map(elem => {
          return elem.barcode || elem.bar_code;
        });
        samplesId = { barcodeList: samplesId };

        this.webSocketPrintSamples({ samplesId, printBatch: false, batch })
          .then(() => {
            this.loadBatchDetailsData();
          })
          .catch(() => {
            this.loadBatchDetailsData();
          });

        this.pushEventToAnalytics('Impressão de uma etiqueta de amostra' + this.batchDetails.source);
      });
    },
    printBatchTag() {
      this.$refs.printingModal.open();
      this.printAndTransmit([
        {
          batchIdentifier: this.batchDetails.barcode,
          sampleSortColumn: this.batchDetails.printSortSelected.value,
          printOnlyBatchTag: 1,
        },
      ])
        .then(() => {
          this.$refs.printingModal.close();
          this.loadBatchDetailsData();
        })
        .catch(() => {
          this.$refs.printingModal.close();
        });
      this.pushEventToAnalytics('Impressão de etiqueta de lote');
    },

    async webSocketPrintBatchTag() {
      await this.executeWithPrinterValidation(() => {
        this.$refs.printingModal.open();
        this.webSocketPrintAndTransmit({
          samples: [],
          barcode: this.batchDetails.barcode,
          printOnlyBatchTag: true,
          source: this.batchDetails.source,
          sampleSortColumn: this.batchDetails?.printSortSelected?.value || null,
        })
          .then(() => {
            this.$refs.printingModal.close();
            this.loadBatchDetailsData();
          })
          .catch(() => {
            this.$refs.printingModal.close();
          });
        this.pushEventToAnalytics('Impressão de etiqueta de lote');
      });
    },
    countTotalExamsWithDocPending() {
      return Object.keys(this.samples).reduce((previous, key) => {
        return previous + this.samples[key].pendingDocCount;
      }, 0);
    },
    alertBatchNotFound() {
      notify({
        title: 'AVISO:',
        message: 'Não foi possível buscar informações de lote no momento.',
        action: {
          title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
          handler: this.pushToSamplesPage,
        },
      });

      this.pushToBatchesPage();
      this.pushEventToAnalytics('Lote não encontrado: ' + this.$route.params.batchid);
    },
    pushToSamplesPage() {
      this.$router.push({ path: '/print-tag/samples/', query: this.$route.query });
    },
    pushToBatchesPage() {
      this.$router.push({ path: '/print-tag/batches/', query: this.$route.query });
    },
    // load batch detail and batch samples by id with route params
    loadBatchDetailsData() {
      if (this.$route.query.tab === 'aol20' || this.$route.query.source === 'AOL2') {
        this.getBatchDetails({ id: this.$route.params.batchid, isWs: false });
        this.getSamplesFromBatch();
      } else {
        this.batcheSetTab('aolWs');
        this.getBatchDetails({ id: this.$route.params.batchid, isWs: true });
        this.isBatchModalLoading = true;
        sampleService.aolwsSampleByBatch(this.$route.params.batchid).then(response => {
          this.samples = response.data;
          if (this.samples && this.samples.length > 0) {
            this.samples = this.samples.map(item => {
              item.bar_code = item.barcode;
              item.patient_name = item.order.patient.name;
              item.number_alvaro_order = item.order.alvaroId;
              item.os_lis = item.order.lisId;
              item.id_material = item.material.id;
              item.material_description = item.material.description;
              return item;
            });
            for (var i = 0; i < this.samples.length; i++) {
              for (var j = 0; j < this.samples[i]['exams'].length; j++) {
                this.samples[i]['exams'][j]['exam_name'] = this.samples[i]['exams'][j]['description'];
                delete this.samples[i]['exams'][j]['description'];
              }
            }
            this.totalSampleExamsWithDocPending = this.countTotalExamsWithDocPending();
          }
          this.isSamplesLoading = false;
        });
      }
    },
    showPDF(batch) {
      const doc = new pdfkit({ size: [165.86, 83.73] });
      const stream = doc.pipe(blobstream());
      var indice;
      var ind = 0;
      this.createBatchLabel(doc, batch);
      this.getSamplesByBatchId(batch.id)
        .then(response => {
          var samples = response.data;
          samples
            .forEach((element, index) => {
              indice = index;
              label.getLabel(element.bar_code).then(response => {
                var samples = response.data;
                samples.forEach(async element => {
                  this.createSampleLabel(doc, element, indice, ind, stream);
                  ind++;
                });
              });
            })
            .catch(() => {
              this.closeLoadingReceptModal();
              notify({
                title: 'AVISO:',
                message: 'Não foi possível buscar informações de lote no momento.',
                action: {
                  title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
                  handler: this.pushToSamplesPage,
                },
              });
              this.pushEventToAnalytics('Impressão de Recibo - Falha ao buscar amostras do lote por ID');
            });
        })
        .catch(() => {
          this.closeLoadingReceptModal();
          notify({
            title: 'AVISO:',
            message: 'Não foi possível buscar informações de lote no momento.',
            action: {
              title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
              handler: this.pushToSamplesPage,
            },
          });
          this.pushEventToAnalytics('Impressão de Recibo - Falha ao buscar amostras do lote por ID');
        });
    },
    createBatchLabel(doc, batch) {
      const date = new Date(batch.created_at.substring(0, 19));

      doc.fontSize(8).text(batch.barcode, {
        width: 55,
        height: 10,
        align: 'left',
      });
      doc.fontSize(6).text('Amostras:' + batch.total_samples, 10, 10, {
        align: 'right',
      });
      doc.image(this.textToBase64Barcode(batch.barcode, 'code39'), 12, 20, { width: 125, height: 40 });
      doc.fontSize(6).text(this.profile.id_laboratory, 10, 65, {
        align: 'left',
      });
      doc.fontSize(6).text(date.toLocaleString('pt-BR'), 25, 65, {
        align: 'left',
      });
      doc.fontSize(8).text('NTO-' + batch.label.substring(0, 3), 10, 72, {
        align: 'left',
      });
      doc.fontSize(8).text(':' + this.getPackagingStatusName(batch.packagingId), 45, 72, {
        align: 'left',
      });
      doc.save();
      doc.rotate(90, { origin: [15, 10] });
      doc.rect(15, 20, 68, 4).fillAndStroke('#black', '#000');

      doc.rotate(90 * -1, { origin: [15, 10] });
      doc.restore();

      if (batch.urgent === true) {
        doc.save();
        doc.rotate(90, { origin: [160, 20] });
        doc.rect(160, 30, 35, 8).fillAndStroke('#black', '#000');
        doc.fillColor('white').fontSize(6).text('URGENCIA', 160, 32).fill('black');
        doc.rotate(90 * -1, { origin: [160, 20] });
        doc.restore();
      }

      doc.rect(112, 70, 33, 10).fillAndStroke('#black', '#000');
      doc
        .fillColor('white')
        .fontSize(8)
        .text(batch.mnemonic + '.' + batch.sequence, 112, 72)
        .fill('black');
      doc.addPage();
    },
    createSampleLabel(doc, element, indice, ind, stream) {
      let str = element.label;
      let regex, label, name, infos, barcode, exam, examDescription, mnemonic, urgent, minimumVolume;
      let labelType = str.substring(1, 3);

      if (labelType === 'XA') {
        regex = /(?<=FD)(.*?)(?=FS)/g;
        label = str.match(regex);
        name = label[0].replace(/['"]+/g, '').replace(/['^]+/g, '');
        infos = label[1].replace(/['"]+/g, '').replace(/['^]+/g, '');
        barcode = label[3].replace(/['"]+/g, '').replace(/['^]+/g, '');
        exam = label[4].replace(/['"]+/g, '').replace(/['^]+/g, '');
        examDescription = label[5].replace(/['"]+/g, '').replace(/['^]+/g, '');
        mnemonic = label[6].replace(/['"]+/g, '').replace(/['^]+/g, '');
      } else {
        regex = /"(?:\\"|[^"])*"/g;
        label = str.match(regex);
        name = label[0].replace(/['"]+/g, '');
        infos = label[1].replace(/['"]+/g, '');
        barcode = label[3].replace(/['"]+/g, '');
        exam = label[4].replace(/['"]+/g, '');
        examDescription = label[5].replace(/['"]+/g, '');
        mnemonic = label[7].replace(/['"]+/g, '');
        urgent = label[8].replace(/['"]+/g, '').replace(/['^]+/g, '');
        minimumVolume = label[6].replace(/['"]+/g, '');
      }
      doc.fontSize(6).text(name, {
        width: 150,
        height: 10,
        align: 'left',
      });
      doc.fontSize(6).text(infos, {
        width: 150,
        height: 15,
        align: 'left',
      });
      doc.image(this.textToBase64Barcode(barcode, 'itf'), 15, 25, { width: 120, height: 30 });
      doc.fontSize(6).text(exam, 10, 55, {
        align: 'left',
      });
      doc.fontSize(6).text(examDescription, 10, 62, {
        align: 'left',
      });
      if (minimumVolume !== '') {
        doc.fontSize(6).text('VOLUME MÍNIMO:' + minimumVolume, 10, 68, {
          align: 'left',
        });
      }
      if (urgent !== '') {
        doc.save();
        doc.rotate(90, { origin: [160, 20] });
        doc.rect(160, 30, 35, 8).fillAndStroke('#black', '#000');
        doc.fillColor('white').fontSize(6).text(urgent, 160, 32).fill('black');
        doc.rotate(90 * -1, { origin: [160, 20] });
        doc.restore();
      }
      doc.rect(123, 57, 33, 10).fillAndStroke('#black', '#000');
      doc.fillColor('white').fontSize(8).text(mnemonic, 123, 59).fill('black');
      if (ind < indice) {
        doc.addPage();
      }
      if (ind === indice) {
        doc.end();
        stream.on('finish', function () {
          const url = stream.toBlobURL('application/pdf');
          window.open(url);
        });
      }
    },
    showPDFBatch(param) {
      const doc = new pdfkit({ size: [165.86, 83.73] });
      const stream = doc.pipe(blobstream());
      const date = new Date(param.created_at.substring(0, 19));

      doc.fontSize(8).text(param.barcode, {
        width: 55,
        height: 10,
        align: 'left',
      });
      doc.fontSize(6).text('Amostras:' + param.total_samples, 10, 10, {
        align: 'right',
      });
      doc.image(this.textToBase64Barcode(param.barcode, 'code39'), 12, 20, { width: 125, height: 40 });
      doc.fontSize(6).text(this.profile.id_laboratory, 10, 65, {
        align: 'left',
      });
      doc.fontSize(6).text(date.toLocaleString('pt-BR'), 25, 65, {
        align: 'left',
      });
      doc.fontSize(8).text('NTO-' + param.label.substring(0, 3), 10, 72, {
        align: 'left',
      });
      doc.fontSize(8).text(':' + this.getPackagingStatusName(param.packagingId), 45, 72, {
        align: 'left',
      });

      if (param.urgent === true) {
        doc.save();
        doc.rotate(90, { origin: [160, 20] });
        doc.rect(160, 30, 35, 8).fillAndStroke('#black', '#000');
        doc.fillColor('white').fontSize(6).text('URGENCIA', 160, 32).fill('black');
        doc.rotate(90 * -1, { origin: [160, 20] });
        doc.restore();
      }

      doc.save();
      doc.rotate(90, { origin: [15, 10] });
      doc.rect(15, 20, 68, 4).fillAndStroke('#black', '#000');

      doc.rotate(90 * -1, { origin: [15, 10] });
      doc.restore();
      doc.rect(112, 70, 33, 10).fillAndStroke('#black', '#000');
      doc
        .fillColor('white')
        .fontSize(8)
        .text(param.mnemonic + '.' + param.sequence, 112, 72)
        .fill('black');
      doc.end();
      stream.on('finish', function () {
        const url = stream.toBlobURL('application/pdf');
        window.open(url);
      });
    },
    showPDFSample(batch) {
      const doc = new pdfkit({ size: [165.86, 83.73] });
      const stream = doc.pipe(blobstream());
      var list = [];
      label
        .getLabel(batch.bar_code)
        .then(response => {
          var samples = response.data;
          list.push(...samples);
          setTimeout(() => {
            for (let i = 0; i < list.length; i++) {
              let str = list[i].label;
              let regex, label, name, infos, barcode, exam, examDescription, mnemonic, urgent, minimumVolume;
              let labelType = str.substring(1, 3);

              if (labelType === 'XA') {
                regex = /(?<=FD)(.*?)(?=FS)/g;
                label = str.match(regex);
                name = label[0].replace(/['"]+/g, '').replace(/['^]+/g, '');
                infos = label[1].replace(/['"]+/g, '').replace(/['^]+/g, '');
                barcode = label[3].replace(/['"]+/g, '').replace(/['^]+/g, '');
                exam = label[4].replace(/['"]+/g, '').replace(/['^]+/g, '');
                examDescription = label[5].replace(/['"]+/g, '').replace(/['^]+/g, '');
                mnemonic = label[6].replace(/['"]+/g, '').replace(/['^]+/g, '');
              } else {
                regex = /"(?:\\"|[^"])*"/g;
                label = str.match(regex);
                name = label[0].replace(/['"]+/g, '');
                infos = label[1].replace(/['"]+/g, '');
                barcode = label[3].replace(/['"]+/g, '');
                exam = label[4].replace(/['"]+/g, '');
                examDescription = label[5].replace(/['"]+/g, '');
                mnemonic = label[7].replace(/['"]+/g, '');
                urgent = label[8].replace(/['"]+/g, '').replace(/['^]+/g, '');
                minimumVolume = label[6].replace(/['"]+/g, '');
              }
              doc.fontSize(6).text(name, {
                width: 150,
                height: 10,
                align: 'left',
              });
              doc.fontSize(6).text(infos, {
                width: 150,
                height: 15,
                align: 'left',
              });
              doc.image(this.textToBase64Barcode(barcode, 'itf'), 15, 25, { width: 120, height: 30 });
              doc.fontSize(6).text(exam, 10, 55, {
                align: 'left',
              });
              doc.fontSize(6).text(examDescription, 10, 62, {
                align: 'left',
              });
              if (minimumVolume !== '') {
                doc.fontSize(6).text('VOLUME MÍNIMO:' + minimumVolume, 10, 68, {
                  align: 'left',
                });
              }
              if (urgent !== '') {
                doc.save();
                doc.rotate(90, { origin: [160, 20] });
                doc.rect(160, 30, 35, 8).fillAndStroke('#black', '#000');
                doc.fillColor('white').fontSize(6).text(urgent, 160, 32).fill('black');
                doc.rotate(90 * -1, { origin: [160, 20] });
                doc.restore();
              }
              doc.rect(123, 57, 33, 10).fillAndStroke('#black', '#000');
              doc.fillColor('white').fontSize(8).text(mnemonic, 123, 59).fill('black');
              if (i < list.length - 1) {
                doc.addPage();
              }
              doc.end();
              stream.on('finish', function () {
                const url = stream.toBlobURL('application/pdf');
                window.open(url);
              });
            }
          }, '500');
        })
        .catch(() => {
          this.closeLoadingReceptModal();
          notify({
            title: 'AVISO:',
            message: 'Não foi possível buscar informações de lote no momento.',
            action: {
              title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
              handler: this.pushToSamplesPage,
            },
          });
          this.pushEventToAnalytics('Impressão de Recibo - Falha ao buscar amostras do lote por ID');
        })
        .catch(() => {
          this.closeLoadingReceptModal();
          notify({
            title: 'AVISO:',
            message: 'Não foi possível buscar informações de lote no momento.',
            action: {
              title: 'IR PARA VISUALIZAÇÃO POR AMOSTRAS',
              handler: this.pushToSamplesPage,
            },
          });
          this.pushEventToAnalytics('Impressão de Recibo - Falha ao buscar amostras do lote por ID');
        });
    },
    validatePrintingSystemForBatch(batchDetails) {
      if (this.toggle.printerPlugin) {
        this.webSocketPrintBatchTag();
      } else if (this.toggle.webPrinting) {
        this.showPDFBatch(batchDetails);
      } else {
        this.printBatchTag();
      }
    },
    validatePrintingSystemForAllSamples(batchDetails) {
      if (this.toggle.printerPlugin) {
        this.webSocketPrintAllSamplesFromBatch();
      } else if (this.toggle.webPrinting) {
        this.showPDF(batchDetails);
      } else {
        this.printAllSamplesFromBatch();
      }
    },
    validatePrintingSystemForSingleSample(sample) {
      if (this.toggle.printerPlugin) {
        this.webSocketPrintSampleFromBatch([sample]);
      } else if (this.toggle.webPrinting) {
        this.showPDFSample(sample);
      } else {
        this.printSampleFromBatch([sample]);
      }
    },
    textToBase64Barcode(barcode, format) {
      var JsBarcode = require('jsbarcode');
      var canvas = document.createElement('canvas');
      JsBarcode(canvas, barcode, { format: format, displayValue: false });
      return canvas.toDataURL('image/png');
    },
    getPackagingStatusName(batch) {
      switch (batch) {
        case 25:
          return 'Congelado';
        case 26:
          return 'Refrigerado';
        case 27:
          return 'Ambiente';
        case 208:
          return 'Refrigerado Seco';
        default:
          return 'Outros';
      }
    },
    getBatchDetails(param) {
      this.isBatchModalLoading = true;
      batchService
        .getBatchDetails(param)
        .then(response => {
          this.batchDetails = response.data;

          if (Object.entries(this.batchDetails).length === 0) {
            this.alertBatchNotFound();
          }

          this.batchDetails.printSortSelected = this.lastSortPrintSelected;
          this.batchDetails.printSortShowOff = true;
          this.isBatchModalLoading = false;
        })
        .catch(() => {
          this.alertBatchNotFound();
        });
    },
    getSamplesFromBatch() {
      this.isSamplesLoading = true;
      batchService
        .getBatchSamples({
          batchId: this.$route.params.batchid,
          docDelivered: this.$route.query.docDelivered,
        })
        .then(response => {
          this.normalizeSamples(response.data);
          this.isSamplesLoading = false;
        })
        .catch(() => {
          this.isSamplesLoading = false;
        });
    },
    normalizeSamples(data) {
      this.samples = data;
      if (this.samples && this.samples.length > 0) {
        this.samples = this.samples.map(item => {
          item.loading = false;
          item.expanded = false;
          delete item.sample_exams;
          return item;
        });
        for (var i = 0; i < this.samples.length; i++) {
          for (var j = 0; j < this.samples[i]['exams'].length; j++) {
            this.samples[i]['exams'][j]['exam_name'] = this.samples[i]['exams'][j]['name'];
            delete this.samples[i]['exams'][j]['name'];
          }
        }
        this.totalSampleExamsWithDocPending = this.countTotalExamsWithDocPending();
      }
    },
    sortColumn(column, columnChild) {
      this.batchDetails.samples = this.samples;
      this.updateBatchDetailsOpened(this.batchDetails);
      this.columnSortStatusSamples[column] = setSortation(column, columnChild, this.columnSortStatusSamples, this.batchSetSortToSamples);
      this.batchDetails = this.batchSamplesSorted;
      this.samples = this.batchSamplesSorted.samples;
      this.pushEventToAnalytics('Ordenação da coluna ' + column);
    },
    openSampleDetails(index, sample) {
      !sample.loading ? this.showSampleDetails(index) : null;
    },
    showSampleDetails(index) {
      let temp = this.samples[index];
      temp.expanded = !temp.expanded;
      this.$set(this.samples, index, temp);
    },
    concatNameCode(name, code) {
      return concatNameAndCode(name, code);
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Impressão de Etiquetas - Detalhes do Lote',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      });
    },
    openConfigModal() {
      this.$refs.printerModal.open();
    },
    handleDownloadPluginRequested() {
      this.$refs.printerPluginDownloadModal.open();
    },
  },
};
</script>

<style lang="scss">
@import '../../../../static/stylesheets/mixins';
@import '../../../../static/stylesheets/variables';
.batch-details {
  .apoio-datatable {
    &__line {
      border-bottom: none !important;
    }
    .row-details {
      &__container {
        padding: 0 15px 10px !important;
        background: #fff !important;
        margin: 0 !important;
      }
    }
  }
  width: 100%;
  .icon-arrow-dropdown {
    &--active {
      transform: rotate(180deg);
    }
  }

  .card-container {
    width: 22%;
    .md-card {
      width: 100%;
    }
  }

  .print-tag-batch-details-list_container {
    vertical-align: center;
    .center {
      text-align: center;
    }
    .apoio-datatable {
      margin-top: 0;
      width: 95%;
      th {
        text-align: center;
      }
      td {
        text-align: center;
      }
    }
    .column-date,
    .column-lis-number,
    .column-os-alvaro,
    .column-printTag,
    .column-narrow {
      width: 20%;
      align-items: center;
    }
    .column-narrow {
      text-align: center;
      padding: 10px 0;
    }

    .column-material {
      width: 200px;
    }

    .print-actions-container {
      width: 10%;
      .md-button {
        font-family: 'Exo 2', sans-serif !important;
        width: 100%;
        height: 2em;
        min-width: 100%;
        letter-spacing: 1px;

        &-printed {
          background-color: darken(#7f1a54, 15%) !important;
        }
      }
    }
  }

  .printTag-date {
    font-size: 10px;
  }

  .subheader_container .subheader-actions-container__turn-back {
    padding-right: 0px !important;
  }

  .subheader__content__right-side {
    width: 80%;
  }

  .container-actions {
    width: 96%;
  }
}
</style>
